import { EventEmitter } from 'events';
export const checkPushNotificationsEnabled = async () => false;
export const disablePushNotifications = () => { };
export const markNotificationTapHandled = (_messageId) => true;
export const resetBadgeCount = async () => { };
export const notificationPressedInForeground = new EventEmitter();
export const getInitialNotificationPress = () => undefined;
export const showForegroundNotification = async () => { };
export const initLocalNotifications = () => { };
